import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const moodFragment = `
    on ${QueryType.product} {
        mood {
            key
            value
        }
    }
`;

export const moodFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: moodFragment
    };
};
